import type { CollectionQueryState, CollectionQueryAdapter } from '@common/adapters/collection-query';
import type { ChatBotChainEntity } from '@common/types/chat-bot-chain.type';

import { createReducer, on } from '@ngrx/store';
import { createCollectionQueryAdapter } from '@common/adapters/collection-query';

import { getQueryKey } from './chat-bot-chains.model';
import ChatBotChainsActions from './chat-bot-chains.actions';

export const CHAT_BOT_CHAINS_COLLECTION_FEATURE_KEY = 'chatBotChains';

export type ChatBotChainsCollectionState = CollectionQueryState<ChatBotChainEntity[]>;

export const chatBotChainsAdapter: CollectionQueryAdapter<ChatBotChainEntity[]> =
    createCollectionQueryAdapter<ChatBotChainEntity[]>();

export const chatBotChainsCollectionReducer = createReducer<ChatBotChainsCollectionState>(
    chatBotChainsAdapter.getInitialState(),
    on(ChatBotChainsActions.loadCollectionRequest, (state: ChatBotChainsCollectionState, { messenger, chatBotId }) =>
        chatBotChainsAdapter.loadCollectionQueryRequest(state, getQueryKey(messenger, chatBotId))
    ),
    on(
        ChatBotChainsActions.loadCollectionSuccess,
        (state: ChatBotChainsCollectionState, { messenger, chatBotId, chatBotChains }) =>
            chatBotChainsAdapter.loadCollectionQuerySuccess(chatBotChains, getQueryKey(messenger, chatBotId), state)
    ),
    on(
        ChatBotChainsActions.loadCollectionFailure,
        (state: ChatBotChainsCollectionState, { messenger, chatBotId, error }) =>
            chatBotChainsAdapter.loadCollectionQueryFailure(error, getQueryKey(messenger, chatBotId), state)
    )
);
